<section class="container">
    <div class="row">
        <div class="col-xs-12">
            <div class="row">
                <div class="col-xs-4">
                    <button type="button" class="btn btn-primary btn-outline btn-lg pull-left" (click)="location.back()">
                        <span class="fa fa-arrow-left"> </span>
                    </button>&nbsp;
                </div>
                <div class="col-xs-8" *ngIf="mode == DisplayMode.Edition">
                    <div class="pull-right text-right" [ngClass]="{'open' : isActionDropdownOpen}">
                        <button class="btn btn-primary btn-lg dropdown-toggle" (click)="isActionDropdownOpen = !isActionDropdownOpen" type="button">
                            <span [i18n]="'user-dashboard.users.form.actions'"></span> <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-right">
                            <li>
                                <a class="dropdown-item"
                                   (click)="openChangePasswordConfirm(changePasswordModal)"
                                   [i18n]="'user-dashboard.users.form.password.change'">
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item"
                                   (click)="toggleBlockingUser()">
                                    <span [i18n]="[{target: 'innerHTML', key: user.blocked ? 'user-dashboard.users.form.@unblock' : 'user-dashboard.users.form.@block', params: {user: userTypeLabel}}]"></span>
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item" *ngIf="user.blockDetails.length !== 0" (click)="unblockUserIp()">
                                    <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.users.form.@unblock-ip', params: {user: userTypeLabel}}]"></span>
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item"
                                   *ngIf="remove != null"
                                   (click)="openDeleteConfirm(deleteModal)">
                                    <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.users.form.@delete', params: {user: userTypeLabel}}]"></span>
                                </a>
                            </li>
                            <li *ngIf="bluechatEnabled && user.bluechatId == null && canActivateBluechat">
                                <a class="dropdown-item" (click)="openBluechatActivationModal(user)">
                                    <span [i18n]="'bluechat.activate'"></span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <bluechat-badge class="pull-right"
                                    *ngIf="bluechatEnabled && mode === DisplayMode.Edition && canActivateBluechat" [bluechatActivated]="user.bluechatEnabled()">
                    </bluechat-badge>
                </div>
            </div>

            <br>

            <div class="ibox float-e-margins">
                <div class="ibox-title border-primary" *ngIf="mode === DisplayMode.Edition">
                    <h5>
                        <span *ngIf="user.email" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.users.form.profile.@label-with-email', params: {email: user.email}}]" ></span>
                        <span *ngIf="!user.email" [i18n]="'user-dashboard.users.form.profile.label'"></span>
                    </h5>
                </div>
                <div class="ibox-content border-primary">
                    <form #userForm="ngForm" (submit)="processForm()" novalidate class="row">
                        <fieldset [disabled]="formProcessingBlocked || (user.carrier && user.carrier.blocked)" class="col-xs-12">
                            <div class="alert alert-warning" *ngIf="user.carrier && user.carrier.blocked">
                                <i class="fa fa-warning"></i>
                                <em [i18n]="'user-dashboard.subcontractors.list.warnings.carrier-disabled'"></em>
                            </div>
                            <div class="alert alert-warning" *ngIf="user.blocked || user.blockDetails.length !== 0">
                                <i class="fa fa-warning"></i>
                                <em [i18n]="'user-dashboard.users.form.block'"></em>
                            </div>

                            <div class="form-group" [ngClass]="{ 'has-error': emailInput.invalid && emailInput.dirty && emailInput.touched }">
                                <label class="control-label" for="user-email" [i18n]="'user-dashboard.users.form.email.label'"></label>
                                <input class="form-control input-lg" name="user-email" id="user-email" type="email" [(ngModel)]="user.email"
                                       [disabled]="user.externalIdpConnectionEnabled"
                                       #emailInput="ngModel" aria-describedby="emailHelp" required (input)="emailChanged()" autocomplete="off">
                                <label class="error" *ngIf="emailInput.dirty && emailInput.touched && emailInput.errors?.required" [i18n]="'validation.required'">
                                </label>
                                <label class="error" *ngIf="emailInput.dirty && emailInput.touched && emailInput.errors?.email" [i18n]="'user-dashboard.users.form.email.not-valid'">
                                </label>
                                <small id="emailHelp" class="help-block m-b-none" [i18n]="user.externalIdpConnectionEnabled ? 'user-dashboard.users.form.email.okta' : 'user-dashboard.users.form.email.help'">
                                </small>
                            </div>

                            <div class="form-group" *ngIf="showRegions">
                                <label class="control-label" for="regions" [i18n]="'user-table.regions'"></label>
                                <ng-select class="regions-select form-control input-lg"
                                           name="regions"
                                           id="regions"
                                           [items]="regions"
                                           [addTag]="false"
                                           bindLabel="name"
                                           bindValue="id"
                                           [hideSelected]="true"
                                           [multiple]="true"
                                           [(ngModel)]="user.allowedRegions"
                                           (change)="changeRegions()"
                                           [i18n]="[
                                            {target: 'attribute:placeholder', key: 'user-dashboard.users.form.regions.no-selected'},
                                            {target: 'attribute:notFoundText', key: 'user-dashboard.users.form.regions.no-found'}
                                           ]">
                                </ng-select>
                            </div>

                            <div class="form-group" *ngIf="showPlants" [ngClass]="{ 'has-warning': atLeastOnePlantHasCoordinatesNotValidated()}">
                                <label class="control-label" for="plants" [i18n]="'user-dashboard.users.form.plants.label'"></label>

                                <ng-select class="plants-select"
                                           name="plants"
                                           id="plants"
                                           [items]="plants"
                                           [virtualScroll]="true"
                                           [addTag]="false"
                                           [i18n]="[{target: 'attribute:placeholder', key: 'user-dashboard.users.form.plants.no-selected'},
                                            {target: 'attribute:notFoundText', key: 'user-dashboard.users.form.plants.no-found'}]"
                                           bindLabel="name"
                                           bindValue="id"
                                           [addTagText]="'add'"
                                           [hideSelected]="true"
                                           [multiple]="true"
                                           [(ngModel)]="user.allowedPlants"
                                           (change)="changeRegions()"
                                           [searchFn]="customPlantSearch">
                                    <ng-template ng-option-tmp let-item="item">
                                        {{ item.glid + ' - ' + item.name }}
                                    </ng-template>
                                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                        <div [ngClass]="hasCoordinatesNotValidated(item)? 'warning': ''">
                                            <span aria-hidden="true" class="ng-value-icon left" (click)="clear(item)">×</span>
                                            <span class="ng-value-label">{{ item.name }}</span>
                                        </div>
                                    </ng-template>
                                </ng-select>

                                <label class="warning" *ngIf="atLeastOnePlantHasCoordinatesNotValidated()" [i18n]="'user-dashboard.users.form.plants.coordinated-not-valid'">
                                </label>
                            </div>

                            <div class="form-group" *ngIf="mode == DisplayMode.Creation" [ngClass]="{ 'has-error': passwordInput.invalid && passwordInput.dirty && passwordInput.touched}">
                                <label class="control-label" for="password" [i18n]="'user-dashboard.users.form.password.label'"></label>
                                <input name="password" type="password" class="form-control input-lg" id="password" required (input)="passwordChanged()"
                                       [(ngModel)]="user.password" #passwordInput="ngModel" arial-describedby="passwordHelp">
                                <label class="error" *ngIf="passwordInput.dirty && passwordInput.errors?.required" [i18n]="'validation.required'">
                                </label>
                            </div>
                            <div class="form-group" *ngIf="mode == DisplayMode.Creation" [ngClass]="{ 'has-error': passwordConfirmInput.invalid && passwordConfirmInput.dirty && passwordConfirmInput.touched }">
                                <label class="control-label" for="password-confirm" [i18n]="'user-dashboard.users.form.password.confirmation'"></label>
                                <input name="password-confirm" type="password" class="form-control input-lg" id="password-confirm" required (input)="passwordChanged()"
                                       [(ngModel)]="passwordConfirmation" #passwordConfirmInput="ngModel" arial-describedby="passwordConfirmHelp">
                                <label class="error" *ngIf="passwordConfirmInput.dirty && passwordConfirmInput.touched && passwordConfirmInput.errors?.dismatch">
                                    {{passwordConfirmInput.errors.dismatch}}
                                </label>
                                <label class="error" *ngIf="passwordConfirmInput.dirty && passwordConfirmInput.touched && passwordConfirmInput.errors?.required" [i18n]="'validation.required'">
                                </label>
                            </div>
                            <div class="form-group" *ngIf="mode == DisplayMode.Edition">
                                <label class="control-label" for="createDateInput" [i18n]="'user-dashboard.users.form.creation-date'"></label>
                                <input name="createDate" type="text" class="form-control input-lg" id="createDateInput" [value]="user.createDateTimestamp | timestamp"
                                       readonly>
                            </div>

                            <div class="form-group" *ngIf="mode == DisplayMode.Edition">
                                <label class="control-label" for="updateDateInput" [i18n]="'user-dashboard.users.form.update-date'"></label>
                                <input name="updateDate" type="text" class="form-control input-lg" id="updateDateInput" [value]="user.updateDateTimestamp | timestamp"
                                       readonly>
                            </div>

                            <div class="form-group" *ngIf="mode == DisplayMode.Edition">
                                <label class="control-label" for="lastLoginInput" [i18n]="'user-dashboard.users.form.last-login'"></label>
                                <input name="lastLogin" type="text" class="form-control input-lg" id="lastLoginInput" placeholder="Never" [value]="user.lastLoginTimestamp | timestamp"
                                       readonly>
                            </div>

                            <div class="form-group" *ngIf="user.carrier">
                                <label class="control-label" for="carrierInput" [i18n]="'user-dashboard.users.form.carrier'"></label>
                                <input id="carrierInput" name="carrierInput" class="form-control input-lg" readonly [ngModel]="user.carrier.name">
                            </div>

                            <div class="form-group" *ngIf="user.subcontractor">
                                <label class="control-label" for="subcontractorInput" [i18n]="'user-dashboard.users.form.sub-carrier'"></label>
                                <input id="subcontractorInput" name="subcontractorInput" class="form-control input-lg" readonly [ngModel]="user.subcontractor.name">
                            </div>

                            <div class="form-buttons">
                                <button type="submit" class="btn btn-primary btn-lg pull-right" [disabled]="userForm.invalid || userForm.pristine || atLeastOnePlantHasCoordinatesNotValidated()">
                                    <span class="fa fa-save space-right-5"></span>
                                    <span [i18n]="mode == DisplayMode.Creation ? 'user-dashboard.users.form.create' : 'user-dashboard.users.form.update'"></span>
                                </button>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>


<ng-template #deleteModal>
    <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.users.form.@delete-confirmation', params: {user: userTypeLabel}}]"></span>
</ng-template>


<ng-template #changePasswordModal>
    <form #changePasswordForm="ngForm" novalidate class="row">
        <div class="form-group" [ngClass]="{ 'has-error': modalPasswordInput.invalid && modalPasswordInput.dirty }">
            <label class="control-label" for="modal-password" [i18n]="'user-dashboard.users.form.password.label'"></label>
            <input name="modal-password" type="password" class="form-control input-lg" id="modal-password" required (input)="modalPasswordChanged()"
                   [(ngModel)]="modalPassword" #modalPasswordInput="ngModel" autocomplete="new-password">

            <label class="error" *ngIf="modalPasswordInput.dirty && modalPasswordInput.errors && modalPasswordInput.errors.required" [i18n]="'validation.required'">
            </label>
        </div>

        <div class="form-group" [ngClass]="{ 'has-error': modalPasswordConfirmInput.invalid && modalPasswordConfirmInput.dirty }">
            <label class="control-label" for="modal-password-confirm" [i18n]="'user-dashboard.users.form.password.confirmation'"></label>
            <input name="modal-password-confirm" type="password" class="form-control input-lg" id="modal-password-confirm" required (input)="modalPasswordChanged()"
                   [(ngModel)]="modalPasswordConfirmation" #modalPasswordConfirmInput="ngModel" autocomplete="new-password">

            <label class="error" *ngIf="modalPasswordConfirmInput.dirty && modalPasswordConfirmInput.errors && modalPasswordConfirmInput.errors.dismatch">
                {{modalPasswordConfirmInput.errors.dismatch}}
            </label>

            <label class="error" *ngIf="modalPasswordConfirmInput.dirty && modalPasswordConfirmInput.errors && modalPasswordConfirmInput.errors.required" [i18n]="'validation.required'">
            </label>
        </div>
    </form>
</ng-template>


<ng-template #bluechatActivationModal let-user="user">
    <div class="m-b-md">
        <span [i18n]="'bluechat.modal.users.content-first'"></span> <strong class="text-primary">{{user.email}}</strong>
    </div>
    <div class="alert alert-info">
        <i class="fa fa-info-circle m-r-xs"></i>
        <span class="m-b-md"><span [i18n]="'bluechat.modal.users.content-second'"></span></span>
    </div>

    <div class="row">
        <div class="col-xs-12 m-b-md text-primary">
            <span [i18n]="'bluechat.modal.users.content-third'"></span>
        </div>
        <div class="col-xs-12 row m-b-md">
            <div class="col-xs-3"><span [i18n]="'bluechat.modal.users.firstname-label'"></span> :</div>
            <div class="col-xs-9"><input type="text" class="form-control" [(ngModel)]="bluechatActivationModalFirstname"></div>
        </div>
        <div class="col-xs-12 row m-b-md">
            <div class="col-xs-3"><span [i18n]="'bluechat.modal.users.lastname-label'"></span> :</div>
            <div class="col-xs-9"><input type="text" class="form-control" [(ngModel)]="bluechatActivationModalLastname"></div>
        </div>
    </div>
    <span [i18n]="'bluechat.modal.users.content-fourth'"></span>
</ng-template>
